import * as React from 'react';
import {CardElement, injectStripe, ReactStripeElements} from 'react-stripe-elements';
import Button from '../../custom_components/button/button.component';
import { StoreState, CustomAction } from '../../store';
import { Dispatch, bindActionCreators } from 'redux';
import { selectGeneric } from '../../store/actions/generic.actions';
import { connect } from 'react-redux';
import { Checkout_Obj, Checkout_Stage_Obj } from '../../store/reducers/checkout_stage.reducers';
import StripeLogo from '../../custom_components/icons/stripe_logo';
import { Signup_Details_Obj } from 'src/store/reducers/signup_details.reducers';
import { Checkout_State_Obj } from 'src/store/reducers/checkout_status.reducer';
import { Signup_Obj } from 'src/store/reducers/signup_input.reducers';

export interface Checkout_Confirm_Response_Obj {
    status: number;
    message: string;
    org_id?: string;
}

export interface Checkout_Props {
    signup_details: Signup_Details_Obj;
    updateStage: typeof selectGeneric;
    updateForm: typeof selectGeneric;
    checkout: Checkout_Obj;
    checkout_state: Checkout_State_Obj;
    checkout_stage: Checkout_Stage_Obj;
}

class CheckoutForm extends React.Component<Checkout_Props & ReactStripeElements.InjectedStripeProps> {
  constructor(props: Checkout_Props & ReactStripeElements.InjectedStripeProps) {
    super(props);
    this.submit = this.submit.bind(this);
  }
  private _card_details_endpoint: string = 'https://1jfd1a63bg.execute-api.ap-southeast-1.amazonaws.com/live';

  async submit(ev: any) {
    // User clicked submit
    console.log(this._card_details_endpoint)
    console.log(this.props.signup_details.email)
    console.log(this.props.stripe)
    if (this.props.stripe != undefined) {
        this.props.updateStage('CHECKOUT_STATE_UPDATE', {loading: true, message: ''})
        let {token} = await this.props.stripe.createToken({name: this.props.signup_details.email});
        console.log(token)
        if (token != undefined) {
            let request = {
                token: token.id,
                email: this.props.signup_details.email,
                org_name: this.props.signup_details.business_name,
                phone_number: this.props.signup_details.mobile_number
            }

            let response = await fetch(this._card_details_endpoint, {
                method: "POST",
                headers: {"Content-Type": "text/plain"},
                body: JSON.stringify(request)
            });
            let body: Checkout_Confirm_Response_Obj = await response.json();
            console.log(body)

            this.props.updateStage('CHECKOUT_STATE_UPDATE', {loading: false, message: body.message})

            if (body.status == 200) {
                // request succeeded >> show email confirm page
                setTimeout(() => {
                    this.props.updateStage('CHECKOUT_STAGE_UPDATE', {stage: '3'}) 
                }, 500)
            } else {
                // show error message
                if ([401, 501].includes(body.status)) {
                    // errors that can be fixed by just trying again
                    setTimeout(() => {
                        this.props.updateStage('CHECKOUT_STATE_UPDATE', {message: 'Please try again. If the issue persists, email us at: info@oneclickhrm.com'})
                    }, 4000)
                } else {
                    // another failure, display the error message, go back after a few seconds

                    if (body.status == 402) {
                        // email address already in use, empty email field, make form invalid
                        let updated_form: Signup_Obj = {
                            value: '',
                            valid: false
                        }
                        this.props.updateForm('SIGNUP_UPDATE', updated_form)

                        let fresh_details: Signup_Details_Obj = {
                            ...this.props.signup_details,
                            email: ''
                        };
                
                        this.props.updateForm('SIGNUP_DETAILS_UPDATE', fresh_details)

                        let updated_checkout: Checkout_Stage_Obj = {
                            ...this.props.checkout_stage,
                            '1': {
                                ...this.props.checkout_stage['1'],
                                form_valid: false
                            }
                        }
            
                        this.props.updateStage('CHECKOUT_UPDATE', updated_checkout)
                    }

                    setTimeout(() => {
                        this.props.updateStage('CHECKOUT_STATE_UPDATE', {message: ''})
                        this.props.updateStage('CHECKOUT_STAGE_UPDATE', {stage: '1'})
                    }, 2500)
                }
            }
        } else {
            this.props.updateStage('CHECKOUT_STATE_UPDATE', {loading: false, message: ''})
        }
    }
  }

  render() {

    return (
      <div className="checkout">
        <div className="checkout-nav-box">
            <StripeLogo height="41px" width="149px"></StripeLogo>
        </div>
        <CardElement />
        <div className="checkout-nav-box">
            <Button 
                className="checkout-nav-button"
                onClick={this.previousStage} 
                disabled={this.props.checkout_state.loading}
                text="Back" 
                color="#673AB7" 
                text_color="white">
            </Button>
            <Button 
                className="checkout-nav-button-pay"
                onClick={this.submit} 
                disabled={this.props.checkout_state.loading}
                text="Confirm" 
                loading={this.props.checkout_state.loading}
                color="#4eabf5" 
                text_color="white">
            </Button>
        </div>
        <div className="checkout-info-text">
            <span className="checkout-cta-trial-text">
                {(this.props.checkout_state.message == '') ?
                    this.props.checkout.comment_text :
                    this.props.checkout_state.message}
            </span>
        </div>
      </div>
    );
  }

  previousStage = () => {
    this.props.updateStage('CHECKOUT_STAGE_UPDATE', {stage: '1'})
    }
}

export function mapStateToProps({ signup_details, checkout_state, checkout_stage }: StoreState) {
    return {
        signup_details: signup_details,
        checkout_state: checkout_state,
        checkout_stage: checkout_stage
    }
}
  
export function mapDispatchToProps(dispatch: Dispatch<CustomAction>) {
    return bindActionCreators({
        updateStage: selectGeneric,
        updateForm: selectGeneric
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(injectStripe(CheckoutForm));


// WEBPACK FOOTER //
// ./src/checkout/form/checkoutForm.tsx